<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <div class="icon-container">
        <i class="fa fa-share-square icon-btn" aria-hidden="true"></i>
      </div>
      <div class="header-text">
        <h2 style="font-weight: 600">Share Documents</h2>
        <p>with " {{ data?.name }} " </p>
      </div>
    </div>
    <i class="fa-regular fa-circle-xmark close-button" (click)="onCancel()"></i>
  </div>

  <div class="dialog-content">
    <form [formGroup]="searchForm">
      <!-- Category & Country Section -->
      <div class="form-row">
        <!-- Category Selection -->
        <div class="category-section">
          <!-- <h3 class="selchoose">Documents - {{ data?.name }} </h3> -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Select Folder</mat-label>
            <mat-select formControlName="categories" 
              (selectionChange)="onCategoryChange($event.value)">
              <mat-option *ngFor="let cat of categoryList" [value]="cat">
                {{ cat.title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
        </div>

      </div>
      <!-- Category & Country Section -->

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-container">
          <i class="material-icons">search</i>
          <input matInput formControlName="searchQuery" placeholder="Search for Document..." (input)="onSearch()">
        </div>
      </div>

      <!-- Connection List -->
      <div class="connection-list">
        <div class="file-card" *ngFor="let file of allFiles; let i = index">
          <div class="file-info">
            <!-- <i class="fa fa-file-alt file-icon"></i> -->
            <img src="assets/img/file.svg" alt="Upload">
            <div>
              <div class="file-names">{{ getDoctypeName(file.doctype || file.name) }}
                  <div class="mconf" *ngIf="file?.matter_details.length!=0"><b class="conf">Confidential:</b> {{ getMatterNames(file) }}</div>
              </div>
              <div class="file-desc">
                {{ formatDate(file.created) }} -
                {{ file.filesize }}

                <span *ngIf="formatDate(file.expiration_date)">
                  - {{ formatDate(file.expiration_date) }}
                </span>

              </div>
            </div>
          </div>
          <!-- <input type="checkbox"  class="select-checkbox" [checked]="file.selected"> -->
          <input type="checkbox" class="select-checkbox" [checked]="isSelected(file.id)"
            (change)="toggleSelection(file, $event)" name="selected_{{file.id}}">

        </div>

        <!-- No Documents Message -->
        <div class="no-docs" *ngIf="searchForm.get('categories')?.value !=='identity' && allFiles?.length === 0">
          No Document(s) found
        </div>
      </div>

      <div class="button-group">
        <button mat-button type="button" class="btn-secondary" (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" class="btn-primary" type="submit" (click)="onShare()">Share</button>
      </div>

    </form>
  </div>
</div>